// 擺放的小工具（平面圖與地圖共用）。
import type { ApiPlacement } from '../../lib/planeApi';
import { sensorKind, type VmsDevice } from '../../lib/devices';

/** 擺放 → VmsDevice.key（`<home_id>/<aid>`）。 */
export function placementKey(p: Pick<ApiPlacement, 'home_id' | 'device_ref'>): string {
  return `${p.home_id}/${p.device_ref}`;
}

/** 放置或移動一個設備（同一張圖一個設備只有一筆）；座標夾在 0..1、角度正規化到 0..360。 */
export function upsertApiPlacement(list: ApiPlacement[], p: ApiPlacement): ApiPlacement[] {
  const clamp = (v: number | undefined) => (v === undefined ? v : Math.min(1, Math.max(0, v)));
  const next = { ...p, x: clamp(p.x), y: clamp(p.y), heading_deg: ((p.heading_deg % 360) + 360) % 360 };
  const k = placementKey(p);
  return [...list.filter((x) => placementKey(x) !== k), next];
}

export function deviceGlyph(d: VmsDevice | undefined): string {
  if (!d) return '❔';
  if (d.isCamera) return '📷';
  if (d.children.length) return '🖥';
  const k = sensorKind(d);
  return k === 'motion' ? '👁' : k === 'contact' ? '🚪' : '📟';
}
